import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { WarrantyFee, warrantyFeeSchema } from '@sophocles/entities/WarrantyFee/warrantyFeeRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_WARRANTY_FEES = 'RECEIVE_WARRANTY_FEES';
function receiveWarrantyFees(json) {
  return {
    type: RECEIVE_WARRANTY_FEES,
    warrantyFees: mapListToRecords(json, WarrantyFee),
  };
}

/* Request Actions */
// starter request
export const REQUEST_WARRANTY_FEE = 'REQUEST_WARRANTY_FEE';
function requestWarrantyFee(warrantyFee_id) {
  return {
    type: REQUEST_WARRANTY_FEE,
    warrantyFee_id,
  };
}

export const REQUEST_ALL_WARRANTY_FEES = 'REQUEST_ALL_WARRANTY_FEES';
function requestAllWarrantyFees() {
  return {
    type: REQUEST_ALL_WARRANTY_FEES,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchWarrantyFee(warrantyFee_id) {
  return dispatch => {
    dispatch(requestWarrantyFee(warrantyFee_id));
    return apiClient
      .get(`/warrantyfees/${warrantyFee_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'warrantyFees', warrantyFeeSchema))
      .then(json => dispatch(receiveWarrantyFees(json.entities.warrantyFees)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_FEE)));
  };
}

export function fetchAllWarrantyFees() {
  return dispatch => {
    dispatch(requestWarrantyFee());
    return apiClient
      .get(`/warrantyfees/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'warrantyFees', warrantyFeeSchema))
      .then(json => dispatch(receiveWarrantyFees(json.entities.warrantyFees)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_FEE)));
  };
}

// USED IN WARRANTY FEE TABLE CALL
export function rawFetchAllWarrantyFee() {
  return dispatch => {
    dispatch(requestAllWarrantyFees());
    return apiClient
      .get(`/warrantyfees/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_FEE)));
  };
}

/* Edit Actions */
export const EDIT_WARRANTY_FEE = 'EDIT_WARRANTY_FEE';
export function editWarrantyFee(warrantyFee_id) {
  return {
    type: EDIT_WARRANTY_FEE,
    warrantyFee: warrantyFee_id,
  };
}

export function patchWarrantyFee(warrantyFee_id, values) {
  return dispatch => {
    dispatch(editWarrantyFee(warrantyFee_id));
    return apiClient
      .patch(`/warrantyfees/${warrantyFee_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, warrantyFeeSchema))
      .then(json => dispatch(receiveWarrantyFees(json.entities.warrantyFees)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_WARRANTY_FEE)));
  };
}

/* Create Actions */
export const CREATE_WARRANTY_FEE = 'CREATE_WARRANTY_FEE';
function sayCreateWarrantyFee(values) {
  return {
    type: CREATE_WARRANTY_FEE,
    values: values,
  };
}

export function createWarrantyFee(values) {
  return dispatch => {
    dispatch(sayCreateWarrantyFee(values));
    return apiClient
      .post(`/warrantyfees/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, warrantyFeeSchema))
      .then(json => dispatch(receiveWarrantyFees(json.entities.warrantyFees)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_WARRANTY_FEE)));
  };
}

/* Delete Actions */
export const DELETE_WARRANTY_FEE = 'DELETE_WARRANTY_FEE';
function sayDeleteWarrantyFee(warrantyFee_id) {
  return {
    type: DELETE_WARRANTY_FEE,
    warrantyFee: warrantyFee_id,
  };
}

export function deleteWarrantyFee(warrantyFee_id) {
  return dispatch =>
    apiClient
      .delete(`/warrantyfees/${warrantyFee_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteWarrantyFee(warrantyFee_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_WARRANTY_FEE)));
}
